<template>
  <div>
    <div
      klickbox-edit-item="general"
      :klickbox-edit-label="$t('edit.canvas.general_styles')">
      <progress-bar v-if="boxConfig.progressbar.kind !== 'counter'"></progress-bar>
      <div class="kbx-content">
        <counter v-if="boxConfig.progressbar.kind === 'counter'"></counter>
        <title-preview></title-preview>
        <description></description>
        <textarea-field v-if="stepActive.text_size === 'long'"></textarea-field>
        <input-field v-else></input-field>
        <button-next></button-next>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ProgressBar from '../../progressbar/Main';
import TitlePreview from './../Title';
import Description from './../Description';
import InputField from './Input';
import TextareaField from './Textarea';
import ButtonNext from './../ButtonNext';
import Counter from './../Counter';

export default {
  components: {
    ProgressBar,
    TitlePreview,
    Description,
    InputField,
    TextareaField,
    ButtonNext,
    Counter,
  },
  computed: mapGetters({
    boxConfig: 'boxConfig',
    stepActive: 'stepActive',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?036f0ace
 **/